import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const schedule = [{
  time: '4:30pm-5:10pm',
  monday: {
    class: 'Basic Program',
    subtext: '(Age 5-8)',
    color: 'bg-yellow-300'
  },
  tuesday: {
    class: 'Basic Program',
    subtext: '(Age 5-8)',
    color: 'bg-yellow-300'
  },
  wednesday: {
    class: 'Basic Program',
    subtext: '(Age 5-8)',
    color: 'bg-yellow-300'
  },
  thursday: {
    class: 'Basic Program',
    subtext: '(Age 5-8)',
    color: 'bg-yellow-300'
  },
  friday: {
    class: 'Hyper',
    subtext: '',
    color: 'bg-cyan-400'
  },
  saturday: {
    class: 'Appointment &',
    subtext: 'Private Lesson',
    color: 'bg-gray-100'
  }
}, {
  time: '5:10pm-5:50pm',
  monday: {
    class: 'Basic Program',
    subtext: '(Age 9 & up)',
    color: 'bg-yellow-300'
  },
  tuesday: {
    class: 'Basic Program',
    subtext: '(Age 9 & up)',
    color: 'bg-yellow-300'
  },
  wednesday: {
    class: 'Basic Program',
    subtext: '(Age 9 & up)',
    color: 'bg-yellow-300'
  },
  thursday: {
    class: 'Basic Program',
    subtext: '(Age 9 & up)',
    color: 'bg-yellow-300'
  },
  friday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  saturday: {
    class: 'Appointments &',
    subtext: 'Private Lesson',
    color: 'bg-gray-100'
  }
}, {
  time: '5:10pm-6:20pm',
  monday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  tuesday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  wednesday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  thursday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  friday: {
    class: 'Beginner',
    subtext: 'Sparring',
    color: 'bg-blue-400'
  },
  saturday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  }
}, {
  time: '5:50pm-6:30pm',
  monday: {
    class: 'Black Belt',
    subtext: '',
    color: 'bg-red-500 text-white'
  },
  tuesday: {
    class: 'Basic Program',
    subtext: '',
    color: 'bg-yellow-300'
  },
  wednesday: {
    class: 'Black Belt',
    subtext: '',
    color: 'bg-red-500 text-white'
  },
  thursday: {
    class: 'Basic Program',
    subtext: '(Family)',
    color: 'bg-yellow-300'
  },
  friday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  saturday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  }
}, {
  time: '6:20pm-7:20pm',
  monday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  tuesday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  wednesday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  thursday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  friday: {
    class: 'Black Belt',
    subtext: '',
    color: 'bg-blue-600 text-white'
  },
  saturday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  }
}, {
  time: '6:30pm-7:20pm',
  monday: {
    class: 'Team 2',
    subtext: 'Adults',
    color: 'bg-gray-400'
  },
  tuesday: {
    class: 'Team 2',
    subtext: 'Adults',
    color: 'bg-gray-400'
  },
  wednesday: {
    class: 'Team 2',
    subtext: 'Adults',
    color: 'bg-gray-400'
  },
  thursday: {
    class: 'Team 2',
    subtext: 'Adults',
    color: 'bg-gray-400'
  },
  friday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  saturday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  }
}, {
  time: '7:20pm-8:30pm',
  monday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  tuesday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  wednesday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  thursday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  friday: {
    class: 'Team',
    subtext: '1&2',
    color: 'bg-gray-400'
  },
  saturday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  }
}, {
  time: '7:20pm-9:00pm',
  monday: {
    class: 'Team 1',
    subtext: '',
    color: 'bg-gray-300'
  },
  tuesday: {
    class: 'Team 1',
    subtext: '',
    color: 'bg-gray-300'
  },
  wednesday: {
    class: 'Team 1',
    subtext: '',
    color: 'bg-gray-300'
  },
  thursday: {
    class: 'Team 1',
    subtext: '',
    color: 'bg-gray-300'
  },
  friday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  },
  saturday: {
    class: '',
    subtext: '',
    color: 'bg-white'
  }
}];
const legend = [{
  label: 'Beg - White - H.Green',
  color: 'bg-yellow-300'
}, {
  label: 'Intermediate - Blue - Red',
  color: 'bg-blue-400'
}, {
  label: 'BB Prep - Bo Dan/Black Belts',
  color: 'bg-red-500 text-white'
}, {
  label: 'Adults - All Belt Levels',
  color: 'bg-gray-400'
}, {
  label: 'Hyper',
  color: 'bg-cyan-400'
}, {
  label: 'Team (Level 1,2, and 3)',
  color: 'bg-gray-300'
}];
export function ScheduleTable() {
  return <section className="py-16 px-4 bg-white" data-id="element-768">
      <div className="max-w-6xl mx-auto" data-id="element-769">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} data-id="element-770">
          {/* Desktop Table */}
          <div className="hidden lg:block overflow-x-auto" data-id="element-771">
            <table className="w-full border-collapse shadow-lg rounded-xl overflow-hidden" data-id="element-772">
              <thead data-id="element-773">
                <tr className="bg-[#0f1f3d] text-white" data-id="element-774">
                  <th className="p-4 text-left font-bold border border-[#0f1f3d]" data-id="element-775">
                    <Clock className="w-5 h-5 inline mr-2" data-id="element-776" />
                    Time
                  </th>
                  <th className="p-4 text-center font-bold border border-[#0f1f3d]" data-id="element-777">
                    Monday (A)
                  </th>
                  <th className="p-4 text-center font-bold border border-[#0f1f3d]" data-id="element-778">
                    Tuesday (A)
                  </th>
                  <th className="p-4 text-center font-bold border border-[#0f1f3d]" data-id="element-779">
                    Wednesday (B)
                  </th>
                  <th className="p-4 text-center font-bold border border-[#0f1f3d]" data-id="element-780">
                    Thursday (B)
                  </th>
                  <th className="p-4 text-center font-bold border border-[#0f1f3d]" data-id="element-781">
                    Friday (Specialty)
                  </th>
                  <th className="p-4 text-center font-bold border border-[#0f1f3d]" data-id="element-782">
                    Saturday
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-783">
                {schedule.map((row, idx) => <tr key={idx} data-id="element-784">
                    <td className="p-4 font-semibold text-gray-700 border border-gray-200 bg-gray-50" data-id="element-785">
                      {row.time}
                    </td>
                    <td className={`p-4 text-center border border-gray-200 ${row.monday.color}`} data-id="element-786">
                      {row.monday.class && <>
                          <div className="font-semibold" data-id="element-787">
                            {row.monday.class}
                          </div>
                          {row.monday.subtext && <div className="text-sm" data-id="element-788">{row.monday.subtext}</div>}
                        </>}
                    </td>
                    <td className={`p-4 text-center border border-gray-200 ${row.tuesday.color}`} data-id="element-789">
                      {row.tuesday.class && <>
                          <div className="font-semibold" data-id="element-790">
                            {row.tuesday.class}
                          </div>
                          {row.tuesday.subtext && <div className="text-sm" data-id="element-791">{row.tuesday.subtext}</div>}
                        </>}
                    </td>
                    <td className={`p-4 text-center border border-gray-200 ${row.wednesday.color}`} data-id="element-792">
                      {row.wednesday.class && <>
                          <div className="font-semibold" data-id="element-793">
                            {row.wednesday.class}
                          </div>
                          {row.wednesday.subtext && <div className="text-sm" data-id="element-794">
                              {row.wednesday.subtext}
                            </div>}
                        </>}
                    </td>
                    <td className={`p-4 text-center border border-gray-200 ${row.thursday.color}`} data-id="element-795">
                      {row.thursday.class && <>
                          <div className="font-semibold" data-id="element-796">
                            {row.thursday.class}
                          </div>
                          {row.thursday.subtext && <div className="text-sm" data-id="element-797">
                              {row.thursday.subtext}
                            </div>}
                        </>}
                    </td>
                    <td className={`p-4 text-center border border-gray-200 ${row.friday.color}`} data-id="element-798">
                      {row.friday.class && <>
                          <div className="font-semibold" data-id="element-799">
                            {row.friday.class}
                          </div>
                          {row.friday.subtext && <div className="text-sm" data-id="element-800">{row.friday.subtext}</div>}
                        </>}
                    </td>
                    <td className={`p-4 text-center border border-gray-200 ${row.saturday.color}`} data-id="element-801">
                      {row.saturday.class && <>
                          <div className="font-semibold" data-id="element-802">
                            {row.saturday.class}
                          </div>
                          {row.saturday.subtext && <div className="text-sm" data-id="element-803">
                              {row.saturday.subtext}
                            </div>}
                        </>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Mobile Schedule */}
          <div className="lg:hidden space-y-6" data-id="element-804">
            {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(day => <div key={day} className="bg-white rounded-xl shadow-lg overflow-hidden border-2 border-[#a3d977]/20" data-id="element-805">
                <div className="bg-[#0f1f3d] text-white p-4 font-bold text-lg" data-id="element-806">
                  {day}
                </div>
                <div className="divide-y divide-gray-200" data-id="element-807">
                  {schedule.map((row, idx) => {
                const dayKey = day.toLowerCase() as keyof typeof row;
                const cell = row[dayKey] as {
                  class: string;
                  subtext: string;
                  color: string;
                };
                if (!cell || !cell.class) return null;
                return <div key={idx} className={`p-4 ${cell.color}`} data-id="element-808">
                        <div className="flex justify-between items-start" data-id="element-809">
                          <div data-id="element-810">
                            <div className="font-semibold" data-id="element-811">{cell.class}</div>
                            {cell.subtext && <div className="text-sm" data-id="element-812">{cell.subtext}</div>}
                          </div>
                          <div className="text-sm font-medium text-gray-600" data-id="element-813">
                            {row.time}
                          </div>
                        </div>
                      </div>;
              })}
                </div>
              </div>)}
          </div>

          {/* Legend */}
          <div className="mt-12 bg-gray-50 rounded-xl p-6 border-2 border-[#a3d977]/20" data-id="element-814">
            <h3 className="text-xl font-bold text-[#0f1f3d] mb-4" data-id="element-815">
              Class Legend
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-816">
              {legend.map((item, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-817">
                  <div className={`w-6 h-6 rounded ${item.color} border border-gray-300`} data-id="element-818"></div>
                  <span className="text-sm font-medium text-gray-700" data-id="element-819">
                    {item.label}
                  </span>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}